import React, { useState } from "react";
import { useSelectorApp } from "../../../lib/redux";
import PropTypes from "prop-types";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { IMAGE_FORMATS } from "../../../utils/constants";
import { useTour } from "@reactour/tour";
import { useTranslationApp } from "../../../lib/i18next";
import { BUTTON_UPLOAD_IMAGE } from "../../../locales/keysTranslations";
import LoadingButton from "./LoadingButton";

const UploadImage = ({
  acceptedFormats = IMAGE_FORMATS,
  hasIcon = true,
  uploadIcon = <CameraAltIcon />,
  multiple = false,
  hasText = true,
  textButton = BUTTON_UPLOAD_IMAGE,
  color = "secondary",
  variant = "contained",
  targetName,
  onReadyUrlImage,
  disabled,
  imageOnboarding = "",
  onChangeImage,
  onCallbackLoading = () => {},
  idUploadComponent = "upload-media",
  isHidden = false,
  sx = {},
}) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslationApp();

  const isNewBrand = useSelectorApp((state) => state.onboarding.isNewBrand);

  const { isOpen } = useTour();

  const getTypeButton = () => {
    if (isOpen && !isNewBrand) return "button";
    if (isOpen && isNewBrand) return "file";
    return "file";
  };

  return (
    <LoadingButton
      sx={{
        display: isHidden ? "none" : "flex",
        borderRadius: 3,
        ...sx,
      }}
      endIcon={hasIcon && !loading && uploadIcon}
      loading={loading}
      component="label"
      disabled={disabled}
      color={color}
      disableElevation
      variant={variant}
      type="button"
    >
      {hasText && t(textButton)}
      <input
        id={idUploadComponent}
        hidden
        multiple={multiple}
        accept={acceptedFormats
          .map((item) => {
            if (IMAGE_FORMATS.includes(item)) return `image/${item},`;
            return `video/${item},`;
          })
          .join(" ")}
        name="image"
        type={getTypeButton()}
        onChange={async (e) => {
          setLoading(true);
          onCallbackLoading(true);
          await onChangeImage(e);
          setLoading(false);
          onCallbackLoading(false);
        }}
        onClick={(e) => {
          if (isOpen && !isNewBrand) {
            e.preventDefault();
            onReadyUrlImage({
              target: { name: targetName, value: imageOnboarding },
            });
          }
        }}
      />
    </LoadingButton>
  );
};

UploadImage.propTypes = {
  hasIcon: PropTypes.bool,
  textButton: PropTypes.string,
  color: PropTypes.string,
  variant: PropTypes.string,
  pathRTDB: PropTypes.string,
  pathStorage: PropTypes.string.isRequired,
  targetName: PropTypes.string.isRequired,
  onReadyUrlImage: PropTypes.func.isRequired,
};

export default UploadImage;
